import React from 'react';
import PropTypes from 'prop-types';
import { UniversalLink } from '@plone/volto/components';

const StatisticView = ({ data }) => {
  const items = data?.items || [];
  const columns = data?.columns || '3';
  const size = data?.size || 'large';

  if (items.length === 0) {
    return (
      <section className="ag-statistic">
        {data?.title && <h2 className="ag-statistic__heading">{data.title}</h2>}
        <p className="ag-statistic__empty">Sem indicadores.</p>
      </section>
    );
  }

  return (
    <section className={`ag-statistic ag-statistic--${size}`}>
      {data.eyebrow && (
        <span className="ag-statistic__eyebrow">{data.eyebrow}</span>
      )}
      {data.title && (
        <h2 className="ag-statistic__heading">{data.title}</h2>
      )}
      <div
        className="ag-statistic__grid"
        style={{ '--ag-stat-cols': columns }}
      >
        {items.map((it, i) => {
          const inner = (
            <>
              <div className="ag-statistic__value">{it.value}</div>
              {it.label && <div className="ag-statistic__label">{it.label}</div>}
              {it.info && <div className="ag-statistic__info">{it.info}</div>}
            </>
          );
          return it.href ? (
            <UniversalLink
              key={it['@id'] || i}
              href={it.href}
              className="ag-statistic__item ag-statistic__item--link"
            >
              {inner}
            </UniversalLink>
          ) : (
            <div key={it['@id'] || i} className="ag-statistic__item">
              {inner}
            </div>
          );
        })}
      </div>
    </section>
  );
};

StatisticView.propTypes = {
  data: PropTypes.shape({
    eyebrow: PropTypes.string,
    title: PropTypes.string,
    columns: PropTypes.string,
    size: PropTypes.string,
    items: PropTypes.array,
  }).isRequired,
};

export default StatisticView;
